import { render, staticRenderFns } from "./GroupNameForm.vue?vue&type=template&id=2b0d84fe&"
import script from "./GroupNameForm.vue?vue&type=script&lang=ts&"
export * from "./GroupNameForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports